export default {
    LOAD_LIST_PERIODO_VIGENCIA(state, data) {
        state.listPeriodoVigencia = data
    },
    PREPARE_TO_EDIT_PERIODO_VIGENCIA(state, data) {
        state.periodoVigencia = data
    },
    RESET_PERIODO_VIGENCIA(state) {
        state.periodoVigencia = {
            id: null,
            nome: '',
            dataInicio: null,
            dataFim: null,
            ativo: true
        }
    },
}
